import { useAddGradeInUrl } from '~/scopes/product-core/components/ProductDetailPageBase/composables/useRedirections/composables/useAddGradeInUrl/useAddGradeInUrl'
import { useGradeFallback } from '~/scopes/product-core/components/ProductDetailPageBase/composables/useRedirections/composables/useGradeFallback/useGradeFallback'
import { useInvalidGradeFallback } from '~/scopes/product-core/components/ProductDetailPageBase/composables/useRedirections/composables/useInvalidGradeFallback/useInvalidGradeFallback'
import { useProductRematch } from '~/scopes/product-core/components/ProductDetailPageBase/composables/useRedirections/composables/useProductRematch/useProductRematch'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

import { useRedirectionToQueryParamsURL } from './composables/useRedirectionToQueryParamsURL/useRedirectionToQueryParamsURL'

export function useRedirections() {
  // Redirect if the fetched product's slug does not match the one in URL
  const { data: productResponse } = useFetchProduct()
  void useProductRematch(productResponse)

  // We delete the grade in the URL if it's invalid
  useInvalidGradeFallback()

  // If the selected grade is not available, we fallback to the first available one
  const { data: pickersResponse, selectedOffer } = useFetchPickers()
  useGradeFallback(pickersResponse)

  // If the grade in the URL is missing, we add it based on the default selected grade for the product
  useAddGradeInUrl(selectedOffer)

  // If the URL has a hash, we redirect to the query params URL
  useRedirectionToQueryParamsURL()
}
